import { UserCompanyEntity } from '@seaters/constants';
import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface CompanyState {
  selectedCompany: UserCompanyEntity | undefined;
  setSelectedCompany: (company: UserCompanyEntity | undefined) => void;
  clearCompany: () => void;
}

export const useCompanyStore = create<CompanyState>()(
  persist(
    (set) => ({
      selectedCompany: undefined,
      setSelectedCompany: (company: UserCompanyEntity | undefined) =>
        set({ selectedCompany: company }),
      clearCompany: () => set({ selectedCompany: undefined }),
    }),
    {
      name: 'seaters-company-store',
    }
  )
);

